export default {
    path: '/appCapabilitiesEdit',
    auth: false,
    preload: false,
    isStatic: true,
    key: 'appCapabilitiesEdit',
    layout: 'inner', // outer 一级菜单 inner 二级菜单
    component: () => import('./index')
  };
  